import { Radio } from "../Radio";
import "../../styles/choice-card.css";
import type { IRadioCardProps } from "./types";

export const RadioCard = ({
  disabled,
  radioPosition = "start",
  className,
  ...radioProps
}: IRadioCardProps) => {
  const rootClassName = [
    "nuco-choice-card",
    `nuco-choice-card--${radioPosition}`,
    disabled && "nuco-choice-card--disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Radio
      disabled={disabled}
      radioPosition={radioPosition}
      {...radioProps}
      className={rootClassName}
      isCard
      renderRadio={undefined}
    />
  );
};
